import React from "react"
import PropTypes from "prop-types"

import { numero, porcentaje } from "../format"

/** Kilos ofertados por los proveedores frente a los kilos pedidos. */
const SupplyCoverageCard = ({ disponibilidad }) => {
  const cobertura = disponibilidad.cobertura_pct
  const cubierto = cobertura === null ? 0 : cobertura
  const sinCubrir = cobertura === null ? 0 : 100 - cobertura

  return (
    <div className="res-cover res-anim">
      <div className="res-cover-head">
        <h3>
          <i className="bx bx-building-house me-1"></i>
          Disponibilidad de proveedores
        </h3>
        <span className="res-cover-count">
          {disponibilidad.proveedores} activos
        </span>
      </div>

      <div className="res-cover-figures">
        <div>
          <div className="res-stat-label">Disponible</div>
          <div className="res-cover-main">
            <span>{numero(disponibilidad.kgs)}</span>
            <span className="res-kpi-unit">kg</span>
          </div>
        </div>
        <div>
          <div className="res-stat-label">Demandado</div>
          <div className="res-cover-side">
            {numero(disponibilidad.kgs_demandados)} kg
          </div>
        </div>
      </div>

      {cobertura === null ? (
        <div className="res-empty-inline">
          Todavía no hay demanda registrada para este día.
        </div>
      ) : (
        <>
          <div className="res-cover-split">
            <span style={{ width: `${cubierto}%` }} />
            <span style={{ width: `${sinCubrir}%` }} />
          </div>
          <div className="res-cover-foot">
            <span>{porcentaje(cubierto)} de la demanda cubierta</span>
            {sinCubrir > 0 && (
              <span className="is-bad">{porcentaje(sinCubrir)} sin cubrir</span>
            )}
          </div>
        </>
      )}
    </div>
  )
}

SupplyCoverageCard.propTypes = {
  disponibilidad: PropTypes.object.isRequired,
}

export default SupplyCoverageCard
